import React from 'react';
import { motion } from 'motion/react';

interface ScrutinyHubProps {
  onOpen: () => void;
}

const ScrutinyHub: React.FC<ScrutinyHubProps> = ({ onOpen }) => {
  return (
    <div className="p-6 sm:p-10 bg-[#3a3430] border border-white/[0.06] rounded-xl relative overflow-hidden h-full min-h-[580px] flex flex-col text-left transition-all">
      <div className="space-y-6 md:space-y-8 flex-1 flex flex-col">
        <div className="flex items-center justify-between">
          <div className="w-8 h-8 rounded bg-[#F26522] text-white flex items-center justify-center font-bold text-sm">
            S
          </div>
          <div className="text-right">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#F26522]">Validation Protocol</span>
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="text-xl font-medium tracking-tight text-white">Scrutiny Deck</h2>
          <p className="text-xs text-white/60 leading-relaxed font-normal">
            Stress-test assumptions. Submit any raw idea. Receive brutal, data-backed analysis of fatal gaps, hidden assumptions, and viable pivot paths with real capital estimates.
          </p>
        </div>

        <div className="p-4 bg-[#322D29] border border-white/[0.08] rounded-lg text-center space-y-1">
          <span className="text-xs font-medium text-white block">Stress-test before you spend</span>
          <span className="text-[10px] text-white/50 uppercase tracking-wider block">Clinical Analysis Protocol</span>
        </div>
      </div>

      <div className="mt-auto pt-6">
        <button 
          onClick={onOpen}
          className="w-full bg-[#F26522] hover:bg-[#F26522]/90 text-white py-3 rounded-lg font-medium uppercase tracking-wider text-xs transition-all flex items-center justify-center gap-2 cursor-pointer"
        >
          <span>Submit for Scrutiny</span>
          <i className="fas fa-microscope text-xs"></i>
        </button>
      </div>
    </div>
  );
};

export default ScrutinyHub;
